import { SELECT_SUGGESTION } from "./actions";
import { PayloadAction } from "@reduxjs/toolkit";

export const selectMatcher = (autocompleteName: string) => (action: PayloadAction<string, string, { name: string }>) =>
    action.type === SELECT_SUGGESTION && action.meta && action.meta.name === autocompleteName;
